import axios from 'axios';
import { xorDecrypt } from '../encrypt';
import { BASE_API_URL } from "../constants";

const getToken = () => {
  const encryptedToken = localStorage.getItem("ABAtoken");
  return xorDecrypt(encryptedToken); // Decrypt the token
};

export const fetchBcbaAssessmentActivities = async () => {
  const response = await axios.post(`${BASE_API_URL}/bcbaassessmentactivities/getall`, {}, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response.data;
};

export const fetchAssessmentPlans = async () => {
  const response = await axios.post(`${BASE_API_URL}/assessment-plans/getall`, {}, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response.data;
};

export const fetchAssessmentNextSteps = async () => {
  const response = await axios.post(`${BASE_API_URL}/assessment-next-steps/getall`, {}, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response.data;
};


export const bcbaActivitiesOptions = [
    {
      label: "Initial Interview & Intake",
      description: {
        activityOne:
          "BCBA conducts an interview with the client’s caregivers, parents, or relevant stakeholders",
        activityTwo:
          "Interview focuses on understanding the client’s background, medical history, strengths, challenges, and specific concerns",
        activityThree:
          "Interview focuses on developmental milestones, communication abilities, social interactions, and problematic behaviors",
      },
    },
    {
      label: "Review of Records",
      description: {
        activityOne:
          "BCBA reviews existing documents, such as previous assessments, medical records, Individualized Education Plans (IEP), or other therapy notes",
        activityTwo:
          "Comprehensive understanding of the client’s history and previous interventions",
      },
    },
    {
      label: "Direct Observation",
      description: {
        activityOne:
          "BCBA observes the client in various environments (e.g., home, school, or therapy center)",
        activityTwo:
          "Observations are conducted during typical daily activities to assess the client’s behavior in natural settings",
        activityThree:
          "The BCBA looks for patterns, triggers (antecedents), and consequences of specific behaviors",
      },
    },
    {
      label: "Functional Behavior Assessment (FBA)",
      description: {
        activityOne:
          "Indirect Assessments: Questionnaires, interviews, or rating scales completed by caregivers or teachers",
        activityTwo:
          "Direct Assessments: Observing and recording the behavior as it naturally occurs",
        activityThree:
          "Functional Analysis: Systematically manipulating variables to determine the triggers and reinforcers of the behavior",
      },
    },
    {
      label: "Skill Assessments",
      description: {
        activityOne:
          "Communication (e.g., verbal, non-verbal, receptive language)",
        activityTwo:
          "Social Skills (e.g., interactions with peers, sharing, turn-taking)",
        activityThree: "Daily Living Skills (e.g., dressing, grooming, eating)",
        activityFour:
          "Academic Skills (e.g., counting, reading, problem-solving)",
        activityFive:
          "Tools such as VB-MAPP, ABLLS-R, or AFLS used for detailed skill assessments",
      },
    },
    {
      label: "Preference Assessment",
      description: {
        activityOne:
          "Identifying the client’s preferred items, activities, or people, which can be used as reinforcers during therapy",
        activityTwo:
          "BCBA used methods like free operant observation, paired-choice, or multiple-stimulus without replacement (MSWO) assessments",
      },
    },
    {
      label: "Development of Treatment Plan",
      description: {
        activityOne:
          "BCBA creates an individualized treatment plan based on the assessment results",
      },
    },
    {
      label: "Feedback Session",
      description: {
        activityOne:
          "Completing the assessment, the BCBA conducts a feedback session with the client’s caregivers or stakeholders",
        activityTwo:
          "BCBA discusses the findings, provides a summary of the assessment, and outlines potential goals for the treatment plan",
      },
    },
  ];